import { FC, useState, ReactNode, Fragment } from 'react';
import { Tooltip } from 'antd';

import { Text, IText } from '../Text';
import classes from './styles.module.scss';

interface ITextWithTooltip extends IText {
  // antd doesn't provide a type for placement. placement should be a string, any for fix TS error
  placement?: string | any;
  arrowPointAtCenter?: boolean;
  tooltipColor?: string;
  title?: string;
  isTitleVisible?: boolean;
}

export const TextWithTooltip: FC<ITextWithTooltip> = ({
  children,
  placement = 'bottomLeft',
  arrowPointAtCenter = true,
  tooltipColor = '#FFFFFF',
  title,
  isTitleVisible = false,
  ...other
}) => {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = (event: any) => {
    const { target } = event;
    if (target.offsetWidth < target.scrollWidth || isTitleVisible) {
      setVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (visible) {
      setVisible(false);
    }
  };

  const formatTooltipText = (text: string): ReactNode => {
    if (!text) return null;

    // Split by newlines and create an array of text and <br/> elements
    const parts = text.split('\n');
    return (
      <Text type="sf-caption">
        {parts.map((part, index) => (
          <Fragment key={index}>
            {part}
            {index < parts.length - 1 && <br />}
          </Fragment>
        ))}
      </Text>
    );
  };

  const renderTooltipTitle = () => {
    if (!title && !children) return null;
    if (title) {
      return formatTooltipText(title);
    }
    if (title) {
      return title;
    }
    // Fallback to using children as title
    return <Text type="sf-caption">{children}</Text>;
  };

  return (
    <Tooltip
      open={visible}
      title={renderTooltipTitle()}
      placement={placement}
      arrowPointAtCenter={arrowPointAtCenter}
      color={tooltipColor}
      overlayClassName="tooltip"
      overlayInnerStyle={{
        padding: '8px 16px'
      }}
    >
      <Text
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={classes.ellipsis}
        {...other}
      >
        {children}
      </Text>
    </Tooltip>
  );
};
